module.exports = __webpack_public_path__ + "img/ele.f409593e.jpeg";